module.exports = __webpack_public_path__ + "img/about.0d118b3a.jpg";